export const CDN_URL =
    "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

export const LOGO_URL =
    "https://i.pinimg.com/originals/b3/8a/a1/b38aa1b21050b0e769a97eb751d12829.png";

export const RESTAURANTS =
    "https://corsproxy.io/?https://www.swiggy.com/dapi/restaurants/list/v5?lat=13.0843007&lng=80.2704622&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING";

export const MENU_STRING_1 =
    "https://corsproxy.io/?https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=23.0787852&lng=72.5368554&restaurantId=";

export const MENU_STRING_2 =
    "&catalog_qa=undefined&isMenuUx4=true&submitAction=ENTER";

export const RESTAURANT_ITEM_CARD =
    "https://corsproxy.io/?https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_300,h_300,c_fit/";

export const GITHUB_USER = "https://api.github.com/users/akshay-kumar-singh";

export const EMPTYCART =
    "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/2xempty_cart_yfxml0";

export const UPDATE_RESTAURANTS =
    "https://corsproxy.io/?https://www.swiggy.com/dapi/restaurants/list/update";
